<script setup>
import SiteContainer from '@/Layouts/Partials/SiteContainer.vue';
import ApplicationLogo from '@/Components/Logo/ApplicationLogo.vue';
import { Head, usePage } from '@inertiajs/vue3';

defineProps({
  title: String
});
</script>

<template>
  <Head>
    <title>{{ title }} - {{ usePage().props.branding.name }}</title>
  </Head>
  <SiteContainer class="mt-8">
    <div class="flex items-center justify-between">
      <ApplicationLogo logo-height="60" />
      <slot name="headerLogo" />
    </div>
    <div class="mt-8 flex flex-col gap-4 md:gap-8">
      <slot />
    </div>
  </SiteContainer>
</template>
